import { useStudentSession } from "../context/StudentSessionContext";

// Shown only when the logged-in parent has more than one enrolled child.
// See the assumption documented in StudentSessionContext.js about how
// switching children maps onto the real backend.
const ChildSwitcher = () => {
  const { student, siblings, activeChildId, setActiveChildId } = useStudentSession();

  if (!siblings || siblings.length < 2) return null;

  return (
    <select
      className="form-select form-select-sm child-switcher"
      value={activeChildId || student?.id || ""}
      onChange={(event) => {
        const selected = siblings.find((sibling) => String(sibling.id) === event.target.value);
        if (selected) setActiveChildId(selected.id, selected.token);
      }}
    >
      {siblings.map((sibling) => (
        <option key={sibling.id} value={sibling.id}>
          {sibling.name}
        </option>
      ))}
    </select>
  );
};

export default ChildSwitcher;
